import { render } from "./TwoFAModal.vue?vue&type=template&id=6a8deeb1"
import script from "./TwoFAModal.vue?vue&type=script&lang=js"
export * from "./TwoFAModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__